module.exports = __webpack_public_path__ + "img/1534.c46773ae.jpg";